import { TEditedData, TPaymentModel } from 'modules/settings/models';
import API from 'services/api';

export const createContractCancellationExpenses = ({
  payload,
}: {
  payload: TPaymentModel | TEditedData;
}) => API.post('/api/cancellation-expenses', payload);
